import React from 'react';

export default () => {
  return (
    <footer class="footer-area">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-4 mt-3">
            <div class="single-footer-widget">
              <h6 class="footer_title">Sobre nós</h6>
              <p>Cogift é um projeto que busca diminuir o impacto da crise econômica causada pelo covid-19. Ajudar negócios a não parar as vendas é fazer com que milhares de trabalhadores não percam seus empregos.</p>
            </div>
          </div>
          <div class="col-12 col-md-4 mt-3">
            <div class="single-footer-widget">
              <h6 class="footer_title">Contato</h6>
              <p><i class="fa fa-envelope"></i> <strong>Contato.cogift@gmail.com</strong></p>
              <p><i class="fa fa-whatsapp"></i> <strong>(11) 9 7399-9599</strong></p>
              <p><i class="fa fa-instagram"></i> <strong>@cogift</strong></p>
            </div>
          </div>	
          <div class="col-12 col-md-4 mt-3 d-flex justify-content-center">
            <div class="single-footer-widget f_social_wd">
              <h6 class="footer_title">Siga a Cogift</h6>
              <p>Let us be social</p>
              <div class="f_social">
                <a href="https://www.instagram.com/cogift/" target="_blank">
                  <i class="fa fa-instagram"></i>
                </a>
                <a href="#"><i class="fa fa-facebook"></i></a>
                <a href="#"><i class="fa fa-twitter"></i></a>
                <a href="#"><i class="fa fa-behance"></i></a>
              </div>
            </div>
          </div>						
        </div>
        <div class="row footer-bottom d-flex justify-content-between align-items-center">
          <p class="col-lg-12 footer-text text-center">
            Copyright &copy;<script>document.write(new Date().getFullYear());</script> All rights reserved | This template is made with <i class="fa fa-heart-o" aria-hidden="true"></i> by <a href="https://colorlib.com" target="_blank">Colorlib</a>
          </p>
        </div>
      </div>
    </footer>
  );
};
